import React from "react";
import { Route } from "react-router-dom";
import CupoyRouter from "components/commons/router/CupoyRouter";
import { GlobalStyle } from 'stylecomponents';
import styled from 'styled-components';
import BreadCrumbs from 'components/commons/BreadCrumbs';
import NewsList from 'components/news/NewsList';
import NewsViewSideBar from 'components/news/NewsViewSideBar';
import NewsContent from 'components/news/NewsContent';

/**
|--------------------------------------------------
| Styled
|--------------------------------------------------
*/
const Container = styled.div`
  width: 100%;
  min-height: 800px;
  display: flex;
  flex-direction: row;
  margin-top: ${GlobalStyle.ViewSpace}px;
`;

const Sidebar = styled.div`
  margin-left: ${GlobalStyle.ViewSpace}px;
  width: 244px;
`;
const Content = styled.div`
  flex: 1;
  min-width: 0;
`;

/**
|--------------------------------------------------
| Main Component
|--------------------------------------------------
*/
const NewsView = () => {
  
  const current = CupoyRouter.getCurrent();
    const { querys = {} } = current;
    const { bclass } = querys;

    const breadCrumbsPaths = {
      preState: 'home',
      preTitle: '首頁',
      title: bclass === '1' ? '最新消息' : '最新活動'
    };

    return (
      <GlobalStyle.SubContainer>
        <BreadCrumbs path={breadCrumbsPaths} />
        <Container>
          <Content>
            <Route path={CupoyRouter.PATHS.NEWS_CONTENT} component={NewsContent} exact />
            {CupoyRouter.isActive(CupoyRouter.STATES.NEWS) && <Route path={CupoyRouter.PATHS.NEWS} component={NewsList} />}
          </Content>
          <Sidebar>
            <NewsViewSideBar />
          </Sidebar>
        </Container>
      </GlobalStyle.SubContainer>
    );
}

/*--------------------------
  export
--------------------------*/
export default NewsView;
